import { useGetAllFavoritesQuery } from '@/services/ApiService.ts';
import { useMemo } from 'react';

export const useUserFavorites = (options?: { skip?: boolean }) => {
    const { data, isFetching, isError } = useGetAllFavoritesQuery(undefined, { skip: options?.skip });

    const occupations = data?.occupations || [];
    const colleges = data?.colleges || [];
    const programs = data?.programs || [];
    const jobs = data?.jobs || [];
    const financialAid = data?.financialAid || [];
    const educationInstitutions = data?.educationInstitutions || [];
    const apprenticeships = data?.apprenticeships || [];
    const credentials = data?.credentials || [];
    const cmi5Courses = data?.cmi5Courses || [];
    const challenges = data?.challenges || [];

    const hasFavorites = useMemo(() => {
        return occupations.length > 0
            || colleges.length > 0
            || programs.length > 0
            || jobs.length > 0
            || financialAid.length > 0
            || educationInstitutions.length > 0
            || apprenticeships.length > 0
            || credentials.length > 0
            || cmi5Courses.length > 0
            || challenges.length > 0;
    }, [occupations.length, colleges.length, programs.length, jobs.length, financialAid.length, educationInstitutions.length, apprenticeships.length, credentials.length, cmi5Courses.length, challenges.length]);

    return {
        occupations,
        colleges,
        programs,
        jobs,
        financialAid,
        educationInstitutions,
        apprenticeships,
        credentials,
        cmi5Courses,
        challenges,
        hasFavorites,
        isFetching,
        isError,
    };
};
